export interface FederatedModuleErrorMeta {
  remoteUrl?: string
  scope: string
  entry: string
}

export interface FederatedModuleError extends Error {
  name: 'FederatedModuleLoadError'
  meta: FederatedModuleErrorMeta
}

export function createFederatedModuleError(
  message: string,
  meta: FederatedModuleErrorMeta
): FederatedModuleError {
  const err = new Error(message) as FederatedModuleError
  err.name = 'FederatedModuleLoadError'
  err.meta = meta
  return err
}

export function toFederatedModuleError(
  error: unknown,
  meta: FederatedModuleErrorMeta
): FederatedModuleError {
  const message = error instanceof Error ? error.message : String(error)
  return createFederatedModuleError(message, meta)
}
